export enum CustomersStepTypeEnum {
    AboutYou = 'ABOUT_YOU',
    Insurance = 'INSURANCE',
    Prescriptions = 'PRESCRIPTIONS',
    Payment = 'PAYMENT',
    Review = 'REVIEW',
    ThankYou = 'THANKYOU',
    Done = 'DONE'
}

export enum CustomersStepTypeEnumPaths {
    ABOUT_YOU = 'about-you',
    INSURANCE = 'insurance',
    PRESCRIPTIONS = 'prescriptions',
    PAYMENT = 'payment',
    REVIEW = 'review',
    THANKYOU = 'thank-you',
    DONE = 'done'
}